<template>
  <div id="AdminHeaderDiv" class="container admin-div" v-if="showAdminHeader()">
    <sdx-loading-spinner id="spinner-adminViewUserEmail" size="large" sr-hint="Loading. Please wait."
                         style="display: none"></sdx-loading-spinner>
    <span class="label sdx-light-theme admin-select-text">Admin Mode: Select another user:</span>
    <sdx-select id="adminViewUserEmail"
                placeholder="Yourself"
                keyboard-behavior="filter"
                filter-min-length="2"
                @input="viewUserEmailChanged"
                v-model="viewUserEmail"
    >
      <sdx-select-option
          class="adminSelectOption"
          v-for="viewUser in viewUserList"
          :key="viewUser.email"
          :value="viewUser.email"
          :selected="isSelectedViewUserEmail(viewUser.email)"
      >
        {{ viewUser.firstName + ' ' + viewUser.lastName + ' (' + viewUser.email + ')' }}
      </sdx-select-option>
    </sdx-select>
  </div>
</template>

<script>
import adminService from '@/services/admin.service';
import userService from '@/services/user.service';
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";

const EVENT_ADMIN_VIEW_EMAIL_CHANGED = "view-email-changed";
const ROUTES_WITH_ADMIN_HEADER = [
  '/statistics',
  '/outbox',
  '/inbox',
  '/sendsms',
  '/campaigns',
  '/campaigns/create',
  '/campaigns/edit',
  '/campaigns/summary',
  '/prefix/allowlist',
  '/subscription/details',
  '/billing/profiles/view/user'
];

export default {
  props: [],
  emits: [EVENT_ADMIN_VIEW_EMAIL_CHANGED],
  data() {
    return {
      isAdmin: false,
      viewUserEmail: "",
      viewUserList: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    showAdminHeader() {
      return this.isAdmin && ROUTES_WITH_ADMIN_HEADER.includes(this.$route.path);
    },
    async loadData() {
      this.isAdmin = await userService.isAdmin()
      if (this.isAdmin) {
        await this.loadViewUserEmailList();
      }
    },
    async loadViewUserEmailList() {
      loadingSpinnerService.show("adminViewUserEmail")
      this.viewUserList = await adminService.getCustomers();
      this.viewUserEmail = await userService.getViewUserEmail();
      loadingSpinnerService.hide("adminViewUserEmail")
    },
    viewUserEmailChanged() {
      this.viewUserEmail = arguments[0].target.value;
      userService.setViewUserEmail(this.viewUserEmail);
      this.notifyDevAppChanged();
    },
    notifyDevAppChanged() {
      logger.debug("EVENT: " + EVENT_ADMIN_VIEW_EMAIL_CHANGED + "(" + this.viewUserEmail + ")");
      this.$emit(EVENT_ADMIN_VIEW_EMAIL_CHANGED, this.viewUserEmail);
    },
    isSelectedViewUserEmail(email) {
      let result = (email !== undefined && this.viewUserEmail !== undefined && this.viewUserEmail !== null &&
          email.toLowerCase() === ("" + this.viewUserEmail).toLowerCase())
      return result;
    }
  }
};
</script>

<style>
.label {
  color: white !important;
  font-size: 16px;
}

.admin-div {
  font-weight: bold;
  background-color: #862351;
  border-radius: 10px;
  margin-top: 10px;
  padding-top: 0px !important;
  padding-bottom: 3px !important;
}

.admin-select-text {
  color: white !important;
}
</style>
